import { CaseTag } from '~/entities/work-unit'
import { FC } from 'react'
import { Box } from '@mui/material'

const MemberFacingCaseAlert: FC<{
  tagKey: string
  style?: React.CSSProperties
}> = props => {
  // Tags are associated with cases
  // However some case categories can also have the isMemberFacing attribute set
  // this attribute signifies that any cases created within the category
  // will have the member facing tag auto applied to it
  // Create a fake tag
  const fakeMemberFacingTag = { id: 1, display_name: 'Member-Facing' }
  return (
    <Box>
      <CaseTag tag={fakeMemberFacingTag} key={props.tagKey} tagKey={props.tagKey}></CaseTag>
    </Box>
  )
}

export default MemberFacingCaseAlert
